import {
  loadAndMigrateState,
  Migrator,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateAssekuranztarif } from './2_migrate_assekuranztarif';
import { migrateSelbstbeteiligung } from './3_migrate_selbstbeteiligung';
import { migrateRasse } from './6_migrate_rasse';
import { migrateRassePyrenaeen } from './10_migrate_rasse_pyrenaeen';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 3,
    migratorFunction: migrateSelbstbeteiligung,
  },
  {
    toVersion: 4,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 5,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 6,
    migratorFunction: migrateRasse,
  },
  {
    toVersion: 7,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 8,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 9,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 10,
    migratorFunction: migrateRassePyrenaeen,
  },
];

export const loadAndMigrateTkvState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
